import { render } from "./RadarChart.vue?vue&type=template&id=115ee300&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=115ee300&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115ee300"]])

export default __exports__